<template>
  <div>
    <div
      ref="audienceCell"
      v-closable="{
        exclude: ['audienceCell'],
        handler: 'closeTooltip'
      }"
      class="grid-link"
    >
      <ejs-tooltip
        v-if="data.audienceId || converted"
        ref="audienceTooltip"
        :content="contentTemplate"
        :css-class="cssClass"
        position="BottomCenter"
        opens-on="Hover"
        :before-open="loadCounts"
        :before-render="setSelectedCampaign"
      >
        <router-link
          :to="{name: 'CampaignDetailsAudience', query: {clientId: $route.query.clientId, companyId: $route.query.companyId, campaignId: data.projectId, userEmail: $route.query.userEmail} }"
          @click.native="closeAudienceTooltip"
        >
          <span
            v-if="!converted"
          >{{ data.audienceName }}</span>
          <span
            v-if="converted"
          >{{ newAudienceName }}</span>
        </router-link>
      </ejs-tooltip>
      <ejs-tooltip
        v-if="!data.audienceId && !converted"
        ref="audienceTooltip"
        :content="contentTemplate"
        :css-class="cssClass"
        position="BottomCenter"
        opens-on="Hover"
        :before-open="loadCounts"
        :before-render="setSelectedCampaign"
      >
        <ejs-tooltip
          v-if="!data.audienceId && !converted"
          ref="newAudienceTooltip"
          :content="newAudienceTemplate"
          :css-class="cssClass"
          position="BottomCenter"
          opens-on="Custom"
          :before-render="setSelectedCampaign"
        >
          Not Set <br>
          <span
            ref="convertToAudienceRef"
            class="link"
            @click="onCustomOpen"
          >Save Audience</span>
        </ejs-tooltip>
      </ejs-tooltip>
    </div>
    <ejs-toast
      ref="errorConvertingRef"
      title="Error"
      content="There is some error converting to audience"
      :position="toastPosition"
      css-class="notification-error"
    />
  </div>
</template>

<script>
import Vue from 'vue'
import { mapGetters, mapState } from 'vuex'

export default {
  data () {
    return {
      cssClass: 'customtip',
      toastPosition: { X: 'Right', Y: 'Top' },
      contentTemplate (data) {
        return {
          template: Vue.component('AudienceTooltipTemplate', {
            data () {
              return {
                data: {},
                countTotal: '',
                countUnique: ''
              }
            },
            computed: {
              ...mapGetters([
                'getAudienceSummary'
              ])
            },
            mounted () {
              this.data = this.$store.getters.getGridSelectedCampaign
              const that = this
              const refreshInterval = setInterval(function () {
                if (that.getAudienceSummary.counts !== undefined) {
                  clearInterval(refreshInterval)
                  if (that.getAudienceSummary.counts) {
                    that.countTotal = that.getAudienceSummary.counts.CountTotal
                    that.countUnique = that.getAudienceSummary.counts.CountUnique
                  } else if (that.getAudienceSummary.counts === null) {
                    that.countTotal = '-'
                    that.countUnique = '-'
                  }
                }
              }, 100)
            },
            template: `<div>
                <span class="tooltip-title">Counts</span><br/>
                <p><span>Customer ({{countTotal | numFormat}})</span><span>, Email ({{countUnique | numFormat}})</span></p>
                <span class="tooltip-title">CASL</span>
                <p v-if="data.includesCASL === true"><font-awesome-icon :icon="['fas', 'circle']" size="xs" class="success" /> Included</p>
                <p v-else-if="data.includesCASL === false"><font-awesome-icon :icon="['fas', 'circle']" size="xs" class="danger" /> Excluded</p>
                <p v-else-if="data.includesCASL === null"><font-awesome-icon :icon="['fas', 'circle']" size="xs" class="failed" /> Not Set</p>
              </div>`
          })
        }
      },
      newAudienceTemplate (data) {
        return {
          template: Vue.component('NewAudienceTemplate', {
            data () {
              return {
                data: {},
                audienceName: '',
                hasError: false
              }
            },
            mounted () {
              this.data = this.$store.getters.getGridSelectedCampaign
            },
            methods: {
              closeTooltipButton () {
                this.$parent.$parent.$parent.closeTooltipButton()
              },
              convertToAudience () {
                if (this.audienceName !== '' && this.audienceName.length < 255) {
                  this.$parent.$parent.$parent.convertToAudience(this.audienceName)
                } else {
                  this.hasError = true
                }
              }
            },
            template: `<div ref="newAudienceTemplate">
                <form id="new-audience-form">
                  <div class="form-group">
                    <label for="audienceName">Audience Name</label>
                    <input type="text" class="form-control" id="audienceName" aria-describedby="" v-model="audienceName" v-bind:style="hasError ? 'border-color:#A82823;' : 'border-color:#ccc;'">
                    <span v-if="audienceName.length > 255">Audience name exceeded 255 characters</span>
                  </div>
                  <div class="text-right">
                    <button type="button" class="btn btn-lg btn-outline-secondary" @click='closeTooltipButton'>Cancel</button>
                    <button type="button" class="btn btn-lg btn-primary ml-2" @click='convertToAudience'>Save</button>
                  </div>
                </form>
              </div>`
          })
        }
      },
      converted: false,
      newAudienceName: ''
    }
  },
  computed: {
    ...mapState({
      isPrimary: state => state.manageCampaigns.isPrimary
    })
  },
  methods: {
    onCustomOpen (args) {
      if (args.target.getAttribute('data-newAudienceTooltip-id')) {
        this.$refs.newAudienceTooltip.close()
      } else {
        this.$refs.newAudienceTooltip.open(args.target)
      }
    },
    loadCounts () {
      const parentCompanyId = this.$route.query.clientId
      const projectId = this.data.projectId
      const userEmail = this.$route.query.userEmail ? atob(this.$route.query.userEmail) : null
      this.$store.commit('SET_AUDIENCE_SUMMARY', {})
      this.$store.dispatch('setCampaignAudienceSummary', { parentCompanyId, projectId, userEmail })
    },
    setSelectedCampaign () {
      this.$store.commit('SET_GRIDSELECTEDCAMPAIGNS', this.data)
    },
    closeTooltip (el, e) {
      if (this.$refs.newAudienceTooltip && document.getElementById('new-audience-form') && !document.getElementById('new-audience-form').contains(e.target)) {
        this.$refs.newAudienceTooltip.close()
      }
    },
    closeTooltipButton () {
      this.$refs.newAudienceTooltip.close()
    },
    closeAudienceTooltip () {
      this.$refs.audienceTooltip.close()
    },
    refreshCampaigns () {
      this.$store.dispatch('setCampaignsByPage', {
        companyId: this.$route.query.companyId,
        isPrimary: this.isPrimary,
        userEmail: atob(this.$route.query.userEmail)
      })
    },
    convertToAudience (audienceName) {
      const projectId = this.data.projectId
      const userEmail = this.$route.query.userEmail ? atob(this.$route.query.userEmail) : null
      this.$store.dispatch('setCampaignConvertToAudience', { projectId, audienceName, userEmail })
        .then(response => {
          console.log('GridAudience setCampaignConvertToAudience: ', response.data.status)
          console.log('GridAudience setCampaignConvertToAudience: ', response)
          if (response.data.status === 200) {
            this.$store.commit('UPDATE_CAMPAIGNS_AUDIENCE', { response: response.data, projectId })
            this.$refs.newAudienceTooltip.close()
            this.refreshCampaigns()
          } else {
            console.log('error converting')
            this.$refs.errorConvertingRef.show()
          }
        }, error => {
          console.log(error)
          console.log('error converting')
          this.$refs.errorConvertingRef.show()
        })
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../../node_modules/@syncfusion/ej2-base/styles/bootstrap4.css";
@import "../../../node_modules/@syncfusion/ej2-vue-notifications/styles/bootstrap4.css";
.link {
  color: $secondary;
  text-decoration: underline;
  &:hover {
    cursor: pointer;
  }
}
.e-tooltip {
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
